export const APP_MODE_STORAGE_KEY = "reelitpro_app_mode";

export const APP_MODES = {
  SIMPLE: "simple",
  FULL: "full",
};

const SIMPLE_MODE_HIDDEN_PATHS = new Set([
  "/trips",
  "/my-gear",
  "/gear-deals",
  "/favorite-spots",
  "/suggested-anglers",
  "/fishipedia",
  "/fishipedia/rankings",
  "/regulations",
  "/records",
  "/news",
  "/school",
  "/feedback",
  "/manual",
  "/surveys",
  "/admin/analytics",
  "/migration/link-supabase",
]);

export function normalizeAppMode(value) {
  return value === APP_MODES.SIMPLE ? APP_MODES.SIMPLE : APP_MODES.FULL;
}

export function getInitialAppMode() {
  if (typeof window === "undefined" || !window.localStorage) {
    return APP_MODES.FULL;
  }

  return normalizeAppMode(window.localStorage.getItem(APP_MODE_STORAGE_KEY));
}

export function setStoredAppMode(mode) {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }

  window.localStorage.setItem(APP_MODE_STORAGE_KEY, normalizeAppMode(mode));
}

export function isSimpleMode(mode) {
  return normalizeAppMode(mode) === APP_MODES.SIMPLE;
}

export function isSimpleModeHiddenPath(pathname, search = "") {
  const normalizedPath = String(pathname || "/").trim() || "/";

  if (normalizedPath === "/") {
    const params = new URLSearchParams(
      String(search || "").startsWith("?") ? search : `?${search || ""}`
    );
    return String(params.get("tab") || "").trim().toLowerCase() === "market";
  }

  return SIMPLE_MODE_HIDDEN_PATHS.has(normalizedPath);
}
